import React from 'react';
import './OptionCard.scss';

function OptionCard({ text, image, onClick }) {
  return (
    <div className="option-card" onClick={onClick}>
      <div className="option-image">
        <img src={image} alt={text} loading="lazy" />
      </div>
    </div>
  );
}

export default OptionCard;